import "./index.css";
import type { ReactNode } from "react";

type IProps = {
  title?: string;
  subtitle?: string;
  children: ReactNode;
};

export const FormView = ({ children, title, subtitle }: IProps) => {
  return (
    <div className="nuco-auth-form-view">
      {(title || subtitle) && (
        <header className="nuco-auth-form-view__header">
          {title && (
            <h3 className="nuco-auth-form-view__title nuco-typography--h3 bold">
              {title}
            </h3>
          )}
          {subtitle && (
            <p className="nuco-auth-form-view__subtitle nuco-typography--body regular">
              {subtitle}
            </p>
          )}
        </header>
      )}
      {children}
    </div>
  );
};
